import { CatExpertRouterLink } from "../../app-routing-enum";

export const dashboardTypes = [
  {
    label: "DASHBOARD.COUNTRY_VIEW",
    value: "country_view",
  },
  {
    label: "DASHBOARD.STORE_VIEW",
    value: "store_view",
  },
];

export const DASHBOARD_TYPES = dashboardTypes.map((item: any) => item.value);

export const DASHBOARD_CARDS = [
  {
    name: "DASHBOARD.COUNTRY_VIEW",
    description: "DASHBOARD.COUNTRY_VIEW_DESC",
    icon: "country-view",
    route: CatExpertRouterLink.DashboardCountryView,
    buttonText: "DASHBOARD.COUNTRY_VIEW",
    show: false,
  },
  {
    name: "DASHBOARD.STORE_VIEW",
    description: "DASHBOARD.STORE_VIEW_DESC",
    icon: "store-view",
    route: CatExpertRouterLink.DashboardStoreView,
    buttonText: "DASHBOARD.STORE_VIEW",
    show: false,
  },
  {
    name: "DASHBOARD.TARGET_SETTING",
    description: "DASHBOARD.COMING_SOON",
    icon: "target-setting",
    route: "",
    buttonText: "DASHBOARD.TARGET_SETTING",
    show: true,
  },
  {
    name: "DASHBOARD.REPORT_GENERATION",
    description: "DASHBOARD.COMING_SOON",
    icon: "report-generation",
    route: "",
    buttonText: "DASHBOARD.REPORT_GENERATION",
    show: true,
  },
];

export const DASHBOARD_SUMMARY = {
  heading: "Dashboard",
  tableColumns: [
    {
      label: "DASHBOARD.NAME",
      value: "name",
      valueType: "",
      filterType: "input_text",
      sortable: true,
      hasEdit: false,
    },
    {
      label: "DASHBOARD.TYPE",
      value: "type",
      valueType: "",
      filterType: "dropdown",
      filterOptions: dashboardTypes,
      selectedFilterValues: [],
      sortable: true,
    },
    {
      label: "DASHBOARD.EXPERIMENTS_LINKED",
      value: "assets_linked",
      valueType: "",
      filterType: "",
      sortable: true,
    },
    {
      label: "DASHBOARD.CREATED_AT",
      value: "created_at",
      valueType: "",
      filterType: "",
      sortable: true,
    },
    {
      label: "DASHBOARD.ACTION",
      value: "action",
      valueType: "icon-view",
      filterType: "",
      sortable: false,
      actionList: [
        {
          label: "DASHBOARD.VIEW",
          key: "view",
          icon: "icon-view-eye",
          color: "#666666",
          callBack: "navigateToDashboard",
          padding: "6px",
        },
        {
          label: "DASHBOARD.SHARE",
          key: "share",
          icon: "share-icon",
          color: "#666666",
          callBack: "shareDashboardLink",
          padding: "6px",
          disabledKey: "access_type",
          disabledValue: "['read', 'edit']",
        },
        {
          label: "DASHBOARD.DELETE",
          key: "delete",
          icon: "icon-delete",
          color: "#DC3545",
          callBack: "deleteDashboard",
          padding: "6px",
          disabledKey: "access_type",
          disabledValue: "['read', 'edit']",
        },
      ],
    },
  ],
};

export const confirmDialogContent = {
  head: "DASHBOARD.DELETE_DASHBOARD",
  description: "DASHBOARD.DELETE_CONFIRM",
  btnCancel: "DASHBOARD.CANCEL",
  btnProceed: "DASHBOARD.DELETE",
  showConfirmDialog: false,
  styleClass: "confirm-dialog",
  dialogkey: "delete",
};

export const tabDetails = [
  {
    heading: "DASHBOARD.MY_DASHBOARD",
    key: "owned",
  },
  {
    heading: "DASHBOARD.SHARED_DASHBOARD",
    key: "shared",
  },
];
